import styled from "styled-components";
import { SectionContainer, SectionContainerWrapper } from "../../library/utilities/SectionContainer";
import { ButtonReset } from "../../library/symbols/buttons";
import { FontFamilyInter } from "../../library/utilities/fonts";
import { Icon } from "../../library/symbols/Icon";
import { breakpointRuleTablet } from "../../library/utilities/variables";
import React from "react";
const HederButton = styled(ButtonReset) `
    ${FontFamilyInter};
    font-size: 14px;
    font-weight: 600;
    line-height: 16px;
    letter-spacing: 0.01em;
`;
const BackButton = styled(HederButton) `
    ${Icon} {
        margin-right: 8px;
    }
`;
const CloseButton = styled(HederButton) `
    ${Icon} {
        margin-left: 8px;
    }
`;
const HeaderContainer = styled(SectionContainer).attrs({ as: "header" }) `
    ${({ positioningAbove }) => positioningAbove && `z-index: 1`};
    padding-top: 20px;

    @media (${breakpointRuleTablet}) {
        padding-top: 60px;
    }
`;
const HeaderSection = styled(SectionContainerWrapper) `
    display: flex;
    justify-content: space-between;

    ${CloseButton} {
        margin-left: auto;
    }
`;
export function Header({ showBack, onBackClick, onCloseClick, positioningAbove }) {
    return (React.createElement(HeaderContainer, { positioningAbove: positioningAbove },
        React.createElement(HeaderSection, null,
            showBack &&
                React.createElement(BackButton, { onClick: () => onBackClick() },
                    React.createElement(Icon, { size: "28", name: "icon-back-button" }),
                    "Volver"),
            React.createElement(CloseButton, { onClick: () => onCloseClick() },
                "Cerrar",
                React.createElement(Icon, { size: "28", name: "icon-close-button" })))));
}
